import { AwsDocument } from "./aws-document";

export class CrmHistoryAwsDocument extends AwsDocument {
	CrmHistoryID:number = 0;

	public constructor(data?:any){
		super(data);
		if (!data) return;
		this.CrmHistoryID = data.CrmHistoryID;
		this.FileID = data.FileID;
	}
}
